import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { LoginComponent } from "./pages/login/login.component";
import { ChatComponent } from "./pages/chat/chat.component";
import { BackupComponent } from "./pages/backup/backup.component";
import { ImgPreviewComponent } from "./pages/img-preview/img-preview.component";
import { UploadPageComponent } from "./pages/uploads/upload-page/upload-page.component";
import { ThemeComponent } from './pages/theme/theme.component';
import { GamesComponent } from './pages/games/games.component';
const routes: Routes = [
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "",
    redirectTo: "/login",
    pathMatch: "full"
  },
  {
    path: "chat",
    component: ChatComponent
  },
  {
    path: "backup",
    component: BackupComponent
  },
  {
    path: "psImage",
    component: ImgPreviewComponent
  },
  {
    path: "uploadPs",
    component: UploadPageComponent
  },
  {
    path: "theme",
    component: ThemeComponent
  },
  {
    path: "games",
    component: GamesComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash:true})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
